module.exports = __webpack_public_path__ + "static/assets/0b4a4faac5634692886876082f5c99c1.png";